<template>
    <div>
        <h1 style="font-size: 24px; color: black;">桌面汪 DogABTest</h1>
        <el-row>
            <el-col>
                <el-button type="primary" @click="showSaveFormDialog('新增组')">新增组</el-button>
            </el-col>
        </el-row>
        <el-button type="primary" @click="getList">查询</el-button>
        <h1>
            <el-table border :data="list">
                <el-table-column prop="id" label="编号" align="center"></el-table-column>
                <el-table-column prop="flag" label="组名" align="center"></el-table-column>
                <el-table-column prop="remark" label="备注" align="center"></el-table-column>
                <el-table-column prop="freeMax" label="免费值" align="center"></el-table-column>
                <el-table-column prop="freeTimes" label="免费次数" align="center"></el-table-column>
                <el-table-column prop="price" label="金币价格" align="center"></el-table-column>
                <el-table-column label="免费次数是否无限" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.freeTimesLimit ? '是' : '否' }}
                    </template>
                </el-table-column>
                <el-table-column label="是否有广告" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.hasAD ? '是' : '否' }}
                    </template>
                </el-table-column>
                <el-table-column label="是否展示二级菜单" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.hasMenu2 ? '是' : '否' }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="showSaveFormDialog('编辑配置',scope.row)">编辑</el-button>
                        <el-button type="text" @click="remove(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.page"
                :page-sizes="[10,20,30]"
                :page-size="page.size"
                layout="total, sizes, prev, pager, next"
                :total="page.totalElements">
            </el-pagination>
        </h1>

        <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="800px">
            <el-form :model="saveForm">
                <el-form-item label="组名" :label-width="labelWidth">
                    <el-input type="text" v-model="saveForm.flag"></el-input>
                </el-form-item>
                <el-form-item label="备注" :label-width="labelWidth">
                    <el-input type="text" v-model="saveForm.remark"></el-input>
                </el-form-item>
                <el-form-item label="免费值" :label-width="labelWidth">
                    <el-input type="text" v-model="saveForm.freeMax" onkeyup="this.value=this.value.replace(/\D/g,'')"></el-input>
                </el-form-item>
                <el-form-item label="免费次数" :label-width="labelWidth">
                    <el-input type="text" v-model="saveForm.freeTimes" onkeyup="this.value=this.value.replace(/\D/g,'')"></el-input>
                </el-form-item>
                <el-form-item label="金币价格" :label-width="labelWidth">
                    <el-input type="text" v-model="saveForm.price" onkeyup="this.value=this.value.replace(/\D/g,'')"></el-input>
                </el-form-item>
                <el-form-item label="免费次数是否无限:" :label-width="labelWidth">
                    <el-switch v-model="saveForm.freeTimesLimit"
                               :active-value="true"
                               :inactive-value="false"
                               active-text="是"
                               inactive-text="否">
                    </el-switch>
                </el-form-item>
                <el-form-item label="是否有广告:" :label-width="labelWidth">
                    <el-switch v-model="saveForm.hasAD"
                               :active-value="true"
                               :inactive-value="false"
                               active-text="是"
                               inactive-text="否">
                    </el-switch>
                </el-form-item>
                <el-form-item label="是否展示二级菜单:" :label-width="labelWidth">
                    <el-switch v-model="saveForm.hasMenu2"
                               :active-value="true"
                               :inactive-value="false"
                               active-text="是"
                               inactive-text="否">
                    </el-switch>
                </el-form-item>
            </el-form>
            <div style="text-align: center;">
                <el-button type="primary" @click="confirmForm">提 交</el-button>
                <el-button type="info" @click="dialogVisible=false">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import app from "@/App.vue";

import {removeABTest, saveABTest, searchABTest} from "@/http/dogApi";

export default {
    name: "DogABTest",
    computed: {
        app() {
            return app
        }
    },
    data() {
        return {
            dialogVisible: false,
            dialogTitle: '',
            labelWidth: '110px',
            list: [],
            saveForm: {
                id: null,
                flag: null,
                remark: null,
                freeMax: null,
                freeTimes: null,
                price: null,
                freeTimesLimit: null,
                hasAD: null,
                hasMenu2: null
            },
            page: {
                size: 10,
                page: 1,
                totalElements: null
            },
            queryData: {},
        }
    },
    methods: {
        handleSizeChange(size) {
            this.page.size = size;
            this.getList();
        },
        handleCurrentChange(page) {
            this.page.page = page;
            this.getList();
        },
        getList() {
            this.queryData.size = this.page.size;
            this.queryData.page = this.page.page;
            searchABTest(this.queryData).then(resp => {
                this.list = resp.data.info.content;
                this.page.totalElements = resp.data.info.totalElements;
            });
        },
        remove(id) {
            this.$confirm('此操作将永久删除该配置, 是否继续?', '提示', {
                cancelButtonClass: 'btn-custom-cancel',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                removeABTest(id).then(resp => {
                    if (resp.data.status === 0) {
                        this.getList();
                    }
                });
            }).catch(() => {
            })
        },
        showSaveFormDialog(_title, _data) {
            this.dialogVisible = true;
            this.dialogTitle = _title;
            this.saveForm = {
                id: null,
                flag: null,
                remark: null,
                freeMax: null,
                price: null,
                freeTimes: null,
                freeTimesLimit: null,
                hasAD: null,
                hasMenu2: null
            };
            if (_data) {
                this.saveForm = {
                    id: _data.id,
                    flag: _data.flag,
                    remark: _data.remark,
                    freeMax: _data.freeMax,
                    price: _data.price,
                    freeTimes: _data.freeTimes,
                    freeTimesLimit: _data.freeTimesLimit,
                    firstSplashAd: _data.firstSplashAd,
                    hasAD: _data.hasAD,
                    hasMenu2: _data.hasMenu2
                }
            }
        },
        confirmForm() {
            saveABTest(this.saveForm).then(resp => {
                if (resp.data.status === 0) {
                    this.getList();
                    this.dialogVisible = false;
                }
            });
        }

    },
    created() {
        this.getList();
    }
}
</script>

<style scoped>

</style>
